import { autoinject, bindable, customElement } from "aurelia-framework";

@customElement("toggle")
@autoinject
export class Toggle {
    @bindable({ defaultBindingMode: "twoWay" })
    value = false;
    @bindable
    leftLabel = "Off";
    @bindable
    rightLabel = "On";

    toggle() {
        this.value = !this.value;
    }
}
